import React from 'react';
import AudioRecorder from '../../utils/test/audioAnalyser';
import IosAudioRecorder from '../../utils/test/iosAudioRecorder';
import { isIos } from '../../../../utils/commonFunctions';
import {
	setResetCounter,
	toggleSubmitActive,
} from '../../../../redux/testPage/testPage.actions';

import { connect } from 'react-redux';
import RecordInstruction from '../../utils/test/recordInstruction';

const ClozeRecorder = ({
	toggleSubmitActive,
	toggleMicPermission,
	handleBlobChange,
	questionNo,
	isMicPermitted,
	rightSectionProps: {
		clozeQuestion,
		questionId,
		question,
		prompt,
		resetCounter,
		resetCounters,
	},
	setResetCounter,
	rightSectionProps,
	dataContainer,
	index,
}) => {
	const updateCounters = (index) => {
		resetCounters[index] = resetCounters[index] - 1;
		localStorage.setItem('resetCounters', resetCounters);
		setResetCounter({
			rightSectionProps: { ...rightSectionProps, resetCounters },
		});

		if (!!resetCounters && resetCounters[index] <= 0) {
			let el = document.getElementsByClassName(`icon_start_${index}`);
			if (!!el && el[0]) el[0].classList.add('disabledElement');
		}
		if (!!resetCounters && resetCounters.every((x) => x < 3)) {
			toggleSubmitActive(false);
		}
	};

	return (
		<span>
			<div
				className="record-container mar-horz pad-horz"
				key={questionId}
				data-container={dataContainer}
				style={{ display: 'none' }}
			>
				<hr />
				<div className="width-80 mar-auto">
					<b>Record the sentence you picked:</b>
					<p
						className="quote text-center cloze-selected"
						style={{ display: 'none' }}
					></p>
				</div>
				<div className="clearfix step-toptions-wrapper" id="div_90681">
					<div className="speaking-question" tabIndex="-1">
						{isMicPermitted && isIos() ? (
							<IosAudioRecorder
								key={questionId}
								error_message={'Please answer this question'}
								updateCounters={updateCounters}
								clozeConvo={true}
								index={index}
							/>
						) : (
							<AudioRecorder
								key={questionId}
								error_message={'Please answer this question'}
								updateCounters={updateCounters}
								clozeConvo={true}
								index={index}
							/>
						)}
						<RecordInstruction resetCounter={resetCounters[index]} index={index} />
						<input
							type="hidden"
							name="resetCounter"
							id="resetCounter"
							value={resetCounter}
						/>
					</div>
				</div>
			</div>
		</span>
	);
};

const mapStateToProps = (state) => {
	const {
		rightSectionProps,
		questionNo,
		isMicPermitted,
	} = state.rootReducer.testPageDetails;

	return {
		rightSectionProps,
		questionNo,
		isMicPermitted,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setResetCounter: (val) => dispatch(setResetCounter(val)),
		toggleSubmitActive: (val) => dispatch(toggleSubmitActive(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ClozeRecorder);
